var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import b64_safe from './b64_safe';
import random from './random';
import hmac from './hmac';
import { getDataFromStorage } from "../auth.helper";
export const generate_short_token_secret = ({ aud, rnd, at0 }, tgt) => __awaiter(void 0, void 0, void 0, function* () {
    const audience_secret = "";
    return yield hmac({ key: tgt, msg: `${aud}.${audience_secret}.${rnd}.${at0}` });
});
const getDeltaTimeServer = () => {
    return 0;
    if (!window.myStorage || !window.myStorage.serverDeltaTime) {
        return 0;
    }
    return parseInt(window.myStorage.serverDeltaTime, 10);
};
export default function generate_jwt(tgt_timestamp, tgt, member_id) {
    return __awaiter(this, void 0, void 0, function* () {
        const header_json = '{"alg":"HS256","typ":"JWT"}';
        const header_b64 = b64_safe(header_json);
        const payload = {
            sub: parseInt(member_id.toString()),
            aud: getDataFromStorage().audience,
            rnd: random(),
            at0: parseInt(tgt_timestamp, 10),
            exp: parseInt((Date.now() / 1000) + getDeltaTimeServer(), 10) + 300
        };
        const payload_json = JSON.stringify(payload);
        const payload_b64 = b64_safe(payload_json);
        const data = `${header_b64}.${payload_b64}`;
        const secret = yield generate_short_token_secret(payload, tgt);
        const signature = yield hmac({ key: secret, msg: data });
        return `${data}.${signature}`;
    });
}
